"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkArrowWrapper = exports.LinkArrowComponent = exports.FeatureMenuLink = exports.FeatureMenuItem = exports.FeatureMenuButton = void 0;
exports.PrimaryNavTrayMenuItem = PrimaryNavTrayMenuItem;
exports.TrayDropdownBack = exports.TrayDropdown = exports.TrayContent = exports.PrimaryNavTrayPanelLists = exports.PrimaryNavTrayPanelFeatures = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intentsConfig = _interopRequireDefault(require("./intents.config.js"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _primaryNavTrayPanel = require("./primary-nav-tray-panel");
var _primaryNavTrayFeature = require("./primary-nav-tray-feature");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

const FeatureMenuItem = exports.FeatureMenuItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "FeatureMenuItem",
  class: "pl-fvfew97",
  vars: {
    "fvfew97-2": [({
      isOpen
    }) => isOpen ? 'visible' : 'hidden']
  }
});
const FeatureMenuElement = `
  padding: 0;
  cursor: pointer;
  font-size: ${_intentsConfig.default.headerNavigatePrimary.fontSize};
  font-weight: ${_intentsConfig.default.headerNavigatePrimary.fontWeight};
  font-family: ${_intentsConfig.default.ux.textTitle.fontFamily};
  border: 0;
  margin: 0;
  line-height: inherit;
  text-transform: none;
  background: inherit;
  overflow: visible;
  text-align: start;
  position: relative;
  
  &:focus:not(:focus-visible) {
    outline: none;
  }

  [data-wrap] & {
    padding: 0;
    opacity: 1;
    font-weight: 500;
  }
`;
const FeatureMenuButton = exports.FeatureMenuButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "FeatureMenuButton",
  class: "pl-fsp77ll",
  vars: {
    "fsp77ll-4": [({
      isOpen
    }) => isOpen ? 'scaleX(1)' : 'scaleX(0)'],
    "fsp77ll-5": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.backgroundColor}` : `${_intentsConfig.default.ux.navigatePrimary.backgroundColor}`],
    "fsp77ll-6": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.foregroundColor}` : `${_intentsConfig.default.ux.navigatePrimary.foregroundColor}`],
    "fsp77ll-7": [({
      isOpen
    }) => isOpen ? `${_intentsConfig.default.ux.navigatePrimaryChosen.borderColor}` : `${_intentsConfig.default.ux.navigatePrimary.borderColor}`]
  }
});
const FeatureMenuLink = exports.FeatureMenuLink = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "FeatureMenuLink",
  class: "pl-f1skc8aq"
});
const LinkArrowWrapper = exports.LinkArrowWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "LinkArrowWrapper",
  class: "pl-l12y9vyl",
  vars: {
    "l12y9vyl-0": [({
      isOpen
    }) => isOpen ? 'none' : 'inline-block']
  }
});
const LinkArrowComponent = exports.LinkArrowComponent = /*#__PURE__*/(0, _react2.styled)(_icon.Icon)({
  name: "LinkArrowComponent",
  class: "pl-lvkuffs"
});
const TrayDropdown = exports.TrayDropdown = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayDropdown",
  class: "pl-tog45qv",
  vars: {
    "tog45qv-3": [({
      isOpen
    }) => isOpen ? 'visible' : 'hidden'],
    "tog45qv-4": [({
      isOpen
    }) => isOpen ? 'scaleY(1)' : 'scaleY(0)'],
    "tog45qv-7": [({
      isOpen
    }) => isOpen ? 'translateX(0)' : 'translateX(-10%)'],
    "tog45qv-8": [({
      isOpen
    }) => isOpen ? 'translateX(-1)' : 'translateX(10%)']
  }
});
const TrayDropdownBack = exports.TrayDropdownBack = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayDropdownBack",
  class: "pl-t1v8bmvn"
});
const TrayContent = exports.TrayContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayContent",
  class: "pl-tab89td",
  vars: {
    "tab89td-0": [({
      isOpen
    }) => isOpen ? '1' : '0'],
    "tab89td-1": [({
      isOpen
    }) => isOpen ? 'translateX(0)' : 'translateX(4rem)'],
    "tab89td-2": [({
      isOpen
    }) => isOpen ? 'visible' : 'hidden'],
    "tab89td-3": [({
      isOpen
    }) => isOpen ? 'translateX(0)' : 'translateX(-4rem)']
  }
});
const PrimaryNavTrayPanelLists = exports.PrimaryNavTrayPanelLists = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PrimaryNavTrayPanelLists",
  class: "pl-pve0akw"
});
const PrimaryNavTrayPanelFeatures = exports.PrimaryNavTrayPanelFeatures = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PrimaryNavTrayPanelFeatures",
  class: "pl-pkv6zmo",
  vars: {
    "pkv6zmo-0": [({
      hasImages
    }) => hasImages ? '1 1' : '0 1'],
    "pkv6zmo-1": [({
      isOpen
    }) => isOpen ? '1' : '0']
  }
});

/**
 * Primary Nav Tray Menu Item component.
 *
 * @param {Object} props React props
 * @param {string} props.text Text string
 * @param {Object} props.primaryNavTray Panel
 * @param {boolean} props.isOpen Boolean for open/closed state
 * @param {boolean} props.isWrap Boolean for wrapped nav state
 * @param {function} props.setIsOpen Setter for panel open state
 * @param {function} props.setIsParentOpen Setter for parent open state
 * @param {number} props.index Index of Menu Item
 * @param {string} props.href Link used if no tray is provided
 * @param {string} props._name name for tracking
 * @returns {React.ReactElement} Primary Nav Tray Menu Item
 * @public
 */
function PrimaryNavTrayMenuItem({
  text,
  primaryNavTray,
  isOpen,
  isParentOpen,
  isWrap,
  setIsOpen,
  setIsParentOpen,
  index,
  href,
  _name
}) {
  const backButton = (0, _react.useRef)(null);
  function toggleMenu(siblings) {
    // Click collapsed FeatureMenuItem
    if (!siblings[index]) {
      setIsParentOpen(true);
      return siblings?.map((sibling, i) => i === index ? !sibling : false);
    }

    // Click expanded FeatureMenuItem in Tablet
    if (isWrap) {
      setIsParentOpen(true);
      return siblings;
    }

    // Click expanded FeatureMenuItem in Desktop
    setIsParentOpen(false);
    return siblings?.map(() => false);
  }
  function hasImages() {
    return primaryNavTray?.featuredImages && primaryNavTray?.featuredImages.length > 0;
  }
  return primaryNavTray ? /*#__PURE__*/_react.default.createElement(FeatureMenuItem, (0, _extends2.default)({
    "data-cy": "primary-nav-tray-menu-item",
    isOpen: isParentOpen
  }, _patternLibraryUtils.tracking.create(_name, true, false), {
    onClick: () => setIsOpen(siblings => {
      return toggleMenu(siblings);
    })
  }), /*#__PURE__*/_react.default.createElement(FeatureMenuButton, {
    isOpen: isOpen,
    "aria-haspopup": "true"
  }, text), /*#__PURE__*/_react.default.createElement(LinkArrowWrapper, {
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(LinkArrowComponent, {
    fill: _intentsConfig.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(TrayDropdown, {
    "data-cy": "tray-dropdown",
    isOpen: isOpen,
    onClick: e => !e.target.hasAttribute('href') && e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(TrayDropdownBack, {
    ref: backButton,
    onClick: () => setIsOpen(siblings => siblings.map(() => false))
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    fill: _intentsConfig.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(TrayContent, {
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(PrimaryNavTrayPanelLists, null, primaryNavTray?.primaryNavMenus?.map(({
    menuTitle,
    href: titleHref,
    menuItems
  }, i) => /*#__PURE__*/_react.default.createElement(_primaryNavTrayPanel.PrimaryNavTrayPanelList, {
    key: i,
    title: menuTitle,
    titleHref: titleHref,
    menuItems: menuItems,
    isOpen: isOpen
  }))), /*#__PURE__*/_react.default.createElement(PrimaryNavTrayPanelFeatures, {
    isOpen: isOpen,
    hasImages: hasImages()
  }, primaryNavTray.featuredImages && primaryNavTray.featuredImages.map(({
    id: featureId,
    image,
    text: featureText,
    href: featureHref,
    _name: featureName
  }, i) => /*#__PURE__*/_react.default.createElement(_primaryNavTrayFeature.PrimaryNavTrayFeature, {
    id: featureId,
    key: i,
    _name: featureName,
    image: image,
    text: featureText,
    href: featureHref
  })))))) : /*#__PURE__*/_react.default.createElement(FeatureMenuItem, {
    isOpen: isParentOpen
  }, /*#__PURE__*/_react.default.createElement(FeatureMenuLink, (0, _extends2.default)({
    href: href
  }, _patternLibraryUtils.tracking.create(_name, true, false)), text));
}
PrimaryNavTrayMenuItem.propTypes = {
  text: _propTypes.default.string,
  primaryNavTray: _propTypes.default.shape({
    primaryNavMenus: _propTypes.default.arrayOf(_propTypes.default.shape({
      menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
        title: _propTypes.default.string
      })),
      href: _propTypes.default.string,
      menuTitle: _propTypes.default.string
    })),
    featuredImages: _propTypes.default.arrayOf(_propTypes.default.shape({
      image: _propTypes.default.PropTypes.shape({
        height: _propTypes.default.number,
        width: _propTypes.default.number,
        altText: _propTypes.default.string,
        url: _propTypes.default.string
      }),
      href: _propTypes.default.string,
      text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
    }))
  }),
  isOpen: _propTypes.default.bool,
  isParentOpen: _propTypes.default.bool,
  isWrap: _propTypes.default.bool,
  setIsOpen: _propTypes.default.func,
  setIsParentOpen: _propTypes.default.func,
  index: _propTypes.default.number,
  href: _propTypes.default.string,
  _name: _propTypes.default.string
};